import { Box } from '@mui/system';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import styled from 'styled-components';
import { formatPriceToKorean } from 'utils/formatUtil';

interface Props {
  range: number;
}

function OwnerCertificationChartTooltip({
  active,
  payload,
  label,
  range,
}: TooltipProps<ValueType, NameType> & Props) {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const payloadData = payload?.[0]?.payload;

  if (!payloadData) {
    return null;
  }

  const { offerCount, price, verificationCount, verificationRate, isLast } =
    payloadData;
  const nextPrice = price + range;

  if (isLast) return null;

  return (
    <TooltipBox>
      <Box component="span">
        {formatPriceToKorean(price)}에서 {formatPriceToKorean(nextPrice)} 사이에
        <OfferCount> {offerCount || 0}개 매물</OfferCount>이 등록 되어 있으며,
        그 중 집주인 인증된 매물은
        <Vertification>
          {' '}
          {verificationCount || 0}개({verificationRate || 0}%)
        </Vertification>{' '}
        입니다.
      </Box>
    </TooltipBox>
  );
}

export default OwnerCertificationChartTooltip;

const TooltipBox = styled.div`
  font-size: 0.6rem;
  background: #fff;
  padding: 10px 10px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 30, 81, 0.12),
    0px 0px 8px 0px rgba(0, 30, 81, 0.04);
  line-height: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  white-space: pre-line;
  word-break: keep-all;
  font-weight: 500;
  max-width: 35%;
  overflow: hidden;
`;

const OfferCount = styled.span`
  color: #333;
  font-weight: 700;
`;

const Vertification = styled.span`
  color: #4584ff;
  font-weight: 700;
`;
